import { createSelector } from 'reselect'

export const artists = state => state.artists;
export const allWorks = state => state.works.all;
export const currentWork = state => state.works.work;
export const currentId = state => state.works.id;
export const lookupTable = state => state.works.lookup;

export const newAdditions = createSelector(
  allWorks,
  works => works.filter(
    w => w.newAddition === 'true'
  )
)

export const worksLoaded = createSelector(
  allWorks,
  works => works.length > 0 ? true : false
)

export const artistsLoaded = createSelector(
  artists,
  artists => artists > 0 ? true : false
)

export const nextId = createSelector(
  allWorks,
  lookupTable,
  currentId,
  (all, lookup, id) => {
    if (id) {
      let idx = lookup[id];
      if (all[idx + 1]) {
        return all[idx + 1].id;
      }
    }
    return false;
  }
)

export const idByIdx = createSelector(
  allWorks,
  works =>  works.map(w => w.id)
)